(function () {
  var collapsible_item = document.getElementsByClassName("section-footer__mobile-collapse");
  var i;
  
  for (i = 0; i < collapsible_item.length; i++) {
    collapsible_item[i].addEventListener("click", function() {
      var parentEl = this.closest('.section-footer__row__col');
      parentEl.classList.toggle("accordion_active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }
})();